import React, { createContext, useEffect, useState } from 'react';
import { string, bool, node } from 'prop-types';
import { determineZipCode } from './helpers/utils';

export const CheckAvailabilityContext = createContext({});

export const CheckAvailabilityProvider = (props) => {
  const {
    isMajorApplianceItemOrItems,
    zipCode,
    children
  } = props;

  useEffect(() => LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('check-availability.ready'), []);

  const [zip, setZip] = useState(determineZipCode(zipCode));
  const shouldDisableInput = zip ? false : true; // eslint-disable-line no-unneeded-ternary
  const [inputButtonDisabled, setInputButtonDisabled] = useState(shouldDisableInput);

  const onInputChange = (event) => {
    const numericalZip = event?.target?.value?.replace(/\D/, '');
    const isDisabled = numericalZip.length !== 5;
    if (!isDisabled) {
      event?.target?.setCustomValidity(''); // eslint-disable-line no-unused-expressions
    }
    setZip(numericalZip);
    setInputButtonDisabled(isDisabled);
  };

  const contextValue = {
    isMajorApplianceItemOrItems,
    inputButtonDisabled,
    onInputChange,
    setZip,
    zip,
    ...props
  };

  return (
    <CheckAvailabilityContext.Provider value={contextValue}>
      {children}
    </CheckAvailabilityContext.Provider>
  );
};

CheckAvailabilityProvider.propTypes = {
  isMajorApplianceItemOrItems: bool,
  zipCode: string,
  children: node
};

CheckAvailabilityProvider.defaultProps = {
  isMajorApplianceItemOrItems: null,
  zipCode: '',
  children: null
};